import { z } from 'zod';

/**
 * Stable notice-code registry (IMM-307.3), mirroring the `ErrorCode` pattern in
 * `errors/error-codes.ts`. A NOTICE message carries one of these codes; a client
 * renders the localized copy by code via `@immo/i18n` (`notices.*`). The backend
 * stays German-free (ADR 0009) — the code is the localization key, the message
 * `content` is an en-US fallback.
 *
 * Codes follow `{module}.{entity}.{condition}`, each segment kebab-case with no
 * dots, so nested-path navigation resolves `notices.{code}` cleanly.
 */
export const NOTICE_CODES = [
  // A run halted by a step / token / time limit.
  'assistant.run.stopped-limit',
  // A run that failed on a model error, tool-loop throw, or provider refusal.
  'assistant.run.failed',
  // The panel reported the open tab is not on ImmoScout24; nothing was read (IMM-1393.3).
  'assistant.page-read.not-supported',
] as const;

export const NoticeCodeSchema = z.enum(NOTICE_CODES);

export type NoticeCode = z.infer<typeof NoticeCodeSchema>;
